import { render, staticRenderFns } from "./LoadingWidget.vue?vue&type=template&id=35768c4b&scoped=true"
import script from "./LoadingWidget.vue?vue&type=script&lang=js"
export * from "./LoadingWidget.vue?vue&type=script&lang=js"
import style0 from "./LoadingWidget.vue?vue&type=style&index=0&id=35768c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35768c4b",
  null
  
)

export default component.exports